import _ from 'lodash';
import React, {FC} from 'react';

import {KeyboardActionsEnum} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {TimeFormatsEnum} from '../../../helpers/dateTimeHelpers';
import {ConversationBaseModel} from '../../../models/api/conversationModel';
import {InboxModel} from '../../../models/api/inboxModel';
import {ReminderModel} from '../../../models/api/reminderModel';
import {CellsContext} from '../../../store/panels/cells/context/cellsContext';
import {InboxesParameters} from '../../../store/panels/inboxes/parameters/inboxesParameters';
import {ViewerPanelId} from '../../../store/panels/panelStateBase';
import {ConversationTopbarSnooze} from '../viewer/conversation/topbar/conversationTopbarSnooze';
import {makeInboxesTopbarSnoozeTooltipProps} from './inboxesTopbarCommon';
import {InboxesTopbarTooltip} from './inboxesTopbarTooltip';

/*
 * Props.
 */

interface InboxesTopbarSnoozeProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  inboxesParameters: InboxesParameters;
  conversationsInboxes: ReadonlyArray<InboxModel>;
  conversations: ReadonlyArray<ConversationBaseModel>;
  reminderForAll: ReminderModel | undefined;
  timeFormat: TimeFormatsEnum;
  contextNamespaces: ReadonlyArray<string>;
  isBulkActionRequired: boolean;
}

/*
 * Component.
 */

export const InboxesTopbarSnooze: FC<InboxesTopbarSnoozeProps> = (props) => {
  const renderTooltip = () => {
    const tooltipProps = makeInboxesTopbarSnoozeTooltipProps({
      ...props,
      remindersForAll: _.compact([props.reminderForAll]),
    });
    return (
      <InboxesTopbarTooltip
        keyboardAction={KeyboardActionsEnum.SNOOZE}
        firstLine={tooltipProps.firstLine || tooltipProps.mainButton}
        secondLine={tooltipProps.secondLine}
      />
    );
  };

  return (
    <ConversationTopbarSnooze
      panelId={props.panelId}
      cellsContext={props.cellsContext}
      contextNamespaces={props.contextNamespaces}
      inboxesParameters={props.inboxesParameters}
      conversations={props.conversations}
      reminderForAll={props.reminderForAll}
      timeFormat={props.timeFormat}
      isBulkActionRequired={props.isBulkActionRequired}
      renderTooltip={renderTooltip}
      isTooltipMultiline
    />
  );
};
